import { Format, Routing, SortKeys } from "@common/_constants";
import { Search } from "@common/_constants";
import { Button } from "@common/components/Atoms/Button";
import LocalTime from "@common/components/Atoms/LocalTime";
import { TileSize } from "@common/models";
import { ReferralService } from "@pro/_services";
import { DashboardTile } from "@pro/components/Organisms/DashboardTile";
import moment from "moment";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const DashboardTileMyApplicationsNav = () => (
    <div className="c-dashboard__tile-nav">
        <Link
            to={`${Routing.Client.Pro.Applications.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
                }=${Search.JobCandidatePhase.REVIEW}`}
            className="c-link no-underline">
            review
        </Link>
        <Link
            to={`${Routing.Client.Pro.Applications.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
                }=${Search.JobCandidatePhase.CONSIDERATION}`}
            className="c-link no-underline">
            consideration
        </Link>
        <Link
            to={`${Routing.Client.Pro.Applications.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
                }=${Search.JobCandidatePhase.ELIMINATED}`}
            className="c-link no-underline">
            eliminated
        </Link>
        <Link
            to={`${Routing.Client.Pro.Applications.SEARCH}?${
                Search.FacetType.JOB_CANDIDATE_PHASE.key
                }=${Search.JobCandidatePhase.HIRED}`}
            className="c-link no-underline">
            hired
        </Link>
        <Link to={Routing.Client.Pro.Applications.SEARCH} className="c-link no-underline">
            all
        </Link>
    </div>
);

const DashboardMyApplicationsFooter = props => (
    <div className="c-dashboard__tile-footer">
        <Link
            to={Routing.Client.Pro.Applications.SEARCH}
            className="c-button c-button--green">
            see more applications
        </Link>
    </div>
);

interface ApplicationModel {
    job_candidate_id: number
    user_full_name: string
    phase_name: string
    hired_timestamp: string
    job_name: string
    location_city_state_display_name: string
}
interface MyApplicationsProps {
    onApplicationsCounted?: (count:number)=>void
    show: boolean
}
interface MyApplicationsState {
    applications: {
        status: string,
        response: ApplicationModel[]
    }
}
export class MyApplications extends Component<MyApplicationsProps, MyApplicationsState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);

        this.state = {
            applications: {
                status: "pending",
                response: [] as ApplicationModel[]
            }
        }
    }

    componentDidMount() {
        this._abortControllers.search = new AbortController();
        const searchSignal = this._abortControllers.search.signal;
        ReferralService.search({
            page_size: 10,
            order_by: SortKeys.JobCandidate.CREATE_TIMESTAMP,
            my_applications: true,
            current_page: 1
        }, searchSignal).then(resp => {
            if (this.props.onApplicationsCounted) {
                this.props.onApplicationsCounted(resp.results.length);
            }
            this.setState({ applications: { status: "success", response: resp.results } });
        });
    }

    render() {
        const { applications } = this.state;
        if (!this.props.show){
            return null;
        }
        return (
            <DashboardTile
                title="applications"
                description="your most current applications"
                size={TileSize.lg}
                loading={applications.status === "pending"}
                nav={
                    applications.status === "success" &&
                    applications.response.length >= 0 && <DashboardTileMyApplicationsNav />
                }
                footer={<DashboardMyApplicationsFooter />}>
                <div className="c-dashboard__referrals">
                    {applications.status === "success" &&
                        applications.response.map(ref => (
                            <div className="c-dashboard__block" key={ref.job_candidate_id}>
                                <div className="c-dashboard__block-header">
                                    <div className="c-dashboard__block-title">
                                        <Link
                                            className="c-link c-link--magenta"
                                            to={"/applications/" + ref.job_candidate_id}>
                                            {ref.job_name}
                                        </Link>
                                    </div>
                                    <div className="c-dashboard__block-callout">
                                        {ref.phase_name}
                                        <br />
                                        {ref.hired_timestamp && (
                                            <span className="c-dashboard__block-callout--no-lowercase">
                                                {moment.utc().diff(moment(ref.hired_timestamp)) > 0
                                                    ? "started "
                                                    : "starting "}
                                                <LocalTime
                                                    utcTimestamp={ref.hired_timestamp}
                                                    format={Format.Datetime.DATE_ABBR_MONTH}
                                                />
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="c-dashboard__block-body">
                                    <ul>
                                        <li>{ref.location_city_state_display_name}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}

                    {applications.status === "success" &&
                        applications.response.length === 0 && (
                            <div className="c-dashboard__blank">
                                <p className="u-text-gray">
                                    Explore thousands of job listings to see if one of them is right for you.
                                </p>
                            </div>
                        )}
                </div>
            </DashboardTile>
        );
    }
}
